<template>
  <div :class="$style['news-item']">
    <div :class="$style['content__wrap']">
      <div :class="$style.content">
        <div :class="$style['meta-row']">
          <div :class="$style['content__date']">
            {{ formattedDate }}
          </div>

          <!-- Плашка New для самой последней записи -->
          <span
            v-if="isLatest"
            :class="$style['label-new']"
          >
            New
          </span>
        </div>

        <h2 :class="$style['content__title']">
          {{ newsItem.header }}
        </h2>

        <div :class="$style['plans-row']">
          <span
            v-for="plan in planLabels"
            :key="plan"
            :class="[$style['plan-label'], $style[`plan-label--${plan}`]]"
          >
            {{ planTitles[plan] }}
          </span>
        </div>

        <p
          :class="$style['content__description']"
          v-html="newsItem.content"
        />
      </div>

      <div
        :class="[$style['image-wrap'], newsItem.videoData ? $style['image-wrap_play-icon'] : '']"
        v-bind="newsItem.videoData"
        @click="handleImageClick"
      >
        <img
          v-if="newsItem.imageSrc"
          :src="newsItem.imageSrc"
          @click.stop
          alt="News image"
        >
      </div>
    </div>

    <div :class="$style['content__delimiter']" />
  </div>
</template>

<script>
import moment from 'moment';
import videoLayout from '../../../../../videoLayout/main';

export default {
  name: 'LearningCenterNewsCard',
  props: {
    newsItem: {
      type: Object,
      required: true,
    },
    isLatest: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      locales: __,
    };
  },
  computed: {
    formattedDate() {
      return moment(this.newsItem.date).locale(user.locale).format('D MMM YYYY');
    },
    planLabels() {
      if (Array.isArray(this.newsItem.labels) && this.newsItem.labels.length) {
        return this.newsItem.labels;
      }

      return ['all'];
    },
    planTitles() {
      return {
        all: this.locales('lc_news_plan_all'),
        core: this.locales('lc_news_plan_core'),
        advanced: this.locales('lc_news_plan_advanced'),
        business: this.locales('lc_news_plan_business'),
        enterprise: this.locales('lc_news_plan_enterprise'),
      };
    },
  },
  methods: {
    handleImageClick(event) {
      if (!this.newsItem.videoData) {
        return;
      }
      videoLayout.init(event);
    },
  },
};
</script>

<style module src="./learningCenterNewsTab.less" lang="less">
</style>


